module.exports = __webpack_public_path__ + "static/media/bg-workshops.53632cb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/BannerTop/bg-workshops.jpg
// module id = 646
// module chunks = 0